<template>
<div class="contact">

	<!-- 头部 -->
	<zmlmenupage cn-name='联系我们' en-name='Contact Us'></zmlmenupage>

	<zmlpagebanner banner-img='static/img/stlBanner.png' banner-text='让生意走进大未来' cn-name='联系我们' en-name='Contact Us'>
	</zmlpagebanner>

	<div class="contact-container">
		<div class="info contactInfo">
			<!-- <div class="contact-map">
				<zmlmap></zmlmap>
			</div> -->
			<div class="contact-content flexBetween">
				<div class="contact-left">
					<div class="contact-address">
						<p>公司地址</p>
						<p>广州市黄埔区港湾路68号2016</p>
						<p>12th Floor, Ruigang Center, 166 Xiheng Road, Park, Huangpu District, Guangzhou City, Guangdong Province, China</p>
					</div>

					<!-- 移动端可见  查看地图 -->
					<router-link to="../mymap" class="findMap">查看地图</router-link>

					<div class="contact-phone">
						<p class="contact-left-title">联系电话</p>
						<p>020-31700169</p>
					</div>
					<div class="contact-hezuo">
						<p class="contact-left-title">品牌合作</p>
						<p>020-31700169</p>
					</div>
					<div class="contact-email">
						<p class="contact-left-title">联系邮箱</p>
						<p>admin@huoyunjh.com</p>
					</div>
					<div class="contact-ewm">
						<img src="../../static/img/theNo.jpg" width="120" alt="">
						<p>微信公众号</p>
					</div>
				</div>
				<div class="contact-right">
					<p>给我们留言</p>
					<el-form :inline="true" :model="formInline" class="contact-right" enctype="multipart/form-data">
						<div>
							<input type="text" value="" v-model="formInline.name" class="userName" placeholder="姓名" />
						</div>
						<div>
							<input type="text" value="" v-model="formInline.email" class="userEmail" placeholder="邮箱" />
						</div>
						<div>
							<input type="text" value="" v-model="formInline.phone" class="userPhone" placeholder="电话" />
						</div>
						<div>
							<textarea class="userMsg" v-model="formInline.area" placeholder="请输入内容"></textarea>
						</div>
					</el-form>
					<div>
						<button class="userBtn" @click="submitButton">提交</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<gototop></gototop>

</div>
</template>
<script>
import zmlmap from '@/components/map.vue'
import {
	leaveMessage
} from '@/api/api'
export default {
	name: 'contact',
	data() {
		return {
			formInline: {
				name: '',
				email: '',
				phone: '',
				area: ''
			},
		}
	},
	methods: {
		submitButton() {
			if (!this.formInline.name) {
				this.$message.info({
					message: "请填写姓名",
				});
				return;
			}
			if (!this.formInline.email) {
				this.$message.info({
					message: "请填写邮箱",
				});
				return;
			}
			var myemail = /^([a-zA-Z0-9.-])+\@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
			if (!myemail.test(this.formInline.email)) {
				this.$message.info({
					message: "请填写正确的邮箱地址！",
				});
				return;
			}
			var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
			if (!this.formInline.phone) {
				this.$message.info({
					message: "请填写电话",
				});
				return;
			}
			if (!myreg.test(this.formInline.phone)) {
				this.$message.info({
					message: "请填写正确的手机号！",
				});
				return;
			}
			if (!this.formInline.area) {
				this.$message.info({
					message: "请填写内容",
				});
				return;
			}
			var form = new FormData();
			form.append("content", this.formInline.area);
			form.append("email", this.formInline.email);
			form.append("name", this.formInline.name);
			form.append("phone", this.formInline.phone);
			leaveMessage(form).then(res => {
				if (res.code == 200) {
					this.$message.success("留言成功！");
				} else {
					this.$message.error("留言失败请稍后再试！");
				}
				this.formInline.name = "";
				this.formInline.email = "";
				this.formInline.phone = "";
				this.formInline.area = "";
			})
		}
	},
	components: {
		zmlmap
	}
}
</script>
<style scoped="scoped">
.contact-container {
	padding: 100px 0;
}

.contact-content {
	padding: 80px 160px 0 160px;
}

.contact-left {
	width: 490px;
}

.contact-left>div {
	margin-bottom: 45px;
}

.contact-address p:nth-of-type(1) {
	font-size: 16px;
	color: #454545;
}

.contact-address p:nth-of-type(2) {
	font-size: 20px;
	font-weight: bold;
	line-height: 38px;
}

.contact-address p:nth-of-type(3) {
	color: #999999;
	font-size: 14px;
	font-family: arial;
	line-height: 16px;
}

.contact-left-title {
	font-size: 16px;
	color: #454545;
	margin-bottom: 5px;
}

.contact-ewm {
	display: inline-block;
	text-align: center;
	font-size: 14px;
	color: #454545;
}

.contact-ewm img {
	box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.1);
}

.contact-ewm p {
	margin-top: 10px;
}

.contact-right {
	width: 440px;
	height: auto;
}

.contact-right>p {
	font-size: 28px;
	font-weight: bold;
	margin-bottom: 24px;
}

.contact-right>div {
	margin-bottom: 16px;
}

.contact-right input {
	width: 100%;
	height: 48px;
	background: rgba(244, 244, 246, 1);
	border: 1px solid rgba(239, 239, 239, 1);
	padding-left: 10px;
	-webkit-appearance: none;
	-webkit-user-select: auto;
	user-select: auto;
	appearance: none;
}

.contact-right textarea {
	width: 100%;
	height: 140px;
	background: rgba(244, 244, 246, 1);
	border: 1px solid rgba(239, 239, 239, 1);
	padding: 10px;
	box-sizing: border-box;
	font-family: "microsoft yahei";
	resize: none;
	-webkit-appearance: none;
	-webkit-user-select: auto;
	user-select: auto;
	appearance: none;
	outline: none;
}

.userBtn {
	width: 180px;
	height: 48px;
	background: rgba(226, 226, 226, 1);
	color: #ADADB0;
	cursor: pointer;
	outline: none;
	transition: .3s;
}

.userBtn:hover {
	background-color: #127BFD;
	color: #fff;
}

.userBtn {
	margin-bottom: 16px;
}

.contact-right input::placeholder,
.contact-right textarea::placeholder {
	color: #ccc;
}

.findMap {
	display: none;
}

@media only screen and (max-width: 750px) {
	.contact-map {
		display: none;
	}
	.findMap {
		display: block;
		width: 74px;
		text-align: center;
		color: #FFFFFF;
		background-color: #127BFD;
		font-size: 12px;
		border-radius: 20px;
		padding: 5px 10px;
		margin: 30px 0;
	}
	.contact-container {
		padding: 23px 0;
		border-top: 10px solid #F4F4F6;
	}
	.contact-content {
		padding: 0;
		display: block;
	}
	.contact-left,
	.contact-right {
		width: 100%;
		padding: 23px 0;
	}
	.contact-left>.contact-address {
		margin-bottom: 0;
	}
	.contact-address p:nth-of-type(1) {
		font-size: 13px;
		font-weight: bold;
		margin-bottom: 10px;
	}
	.contact-address p:nth-of-type(2) {
		font-size: 15px;
		font-weight: bold;
		line-height: 23px;
	}
	.contact-address p:nth-of-type(3) {
		line-height: 15px;
		font-size: 10px;
		margin-top: 10px;
	}
	.contact-left-title {
		font-size: 13px;
		font-weight: bold;
	}
	.contact-phone p:nth-of-type(2) {
		color: #127BFD;
		font-size: 19px;
		font-family: 'fontBt3';
		font-weight: bold;
	}
	.contact-hezuo,
	.contact-email {
		width: 50%;
		float: left;
	}
	.contact-ewm img {
		width: 100px !important;
	}
	.contact-ewm p {
		font-size: 12px;
	}
	.contact-right>p {
		font-size: 18px;
	}
	.userBtn {
		width: 100%;
		height: 30px;
		margin-top: 24px;
	}
	.contact-right input {
		height: 30px;
	}
	.contact-right textarea {
		height: 110px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue